import { Button } from "@/components/ui/button/button";
import { NavigateOptions, useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { Progress } from "../../ui/progress";

type Props = {
	maxProgress: number;
} & (
	| { isBackButton: true; navigateTo: NavigateOptions }
	| { isBackButton?: false; navigateTo?: NavigateOptions }
);

const SignupHeader: React.FC<Props> = ({
	maxProgress,
	navigateTo,
	isBackButton = true,
}) => {
	const navigate = useNavigate();
	const [progress, setProgress] = useState(0);
	useEffect(() => {
		const timer = setTimeout(() => setProgress(maxProgress), 20);
		return () => clearTimeout(timer);
	}, [maxProgress]);

	return (
		<div className="relative flex justify-center w-full">
			<Progress value={progress} className="max-w-16" />
			{isBackButton && navigateTo && (
				<Button
					variant="ghost"
					className="absolute left-0 max-w-sm pt-0 pl-0 -top-4 [&_svg]:size-6 hover:bg-transparent"
					onClick={() => navigate(navigateTo)}
				>
					<ArrowLeftIcon className="cursor-pointer" />
				</Button>
			)}
		</div>
	);
};

export default SignupHeader;
